import '../../styles/components/admin.css'
import { signIn, getSession } from '../../lib/supabase.js'

export async function renderAdminLogin(outlet) {
  // Already logged in → go to admin dashboard
  const session = await getSession()
  if (session) {
    window.location.hash = '#/admin'
    return
  }

  outlet.innerHTML = `
    <div class="admin-login-wrap">
      <div class="admin-login-card">
        <div class="admin-login-logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24" aria-hidden="true">
            <path d="M 96 391 C 71 -22, 443 -22, 443 377 C 443 433, 387 455, 352 399 C 367 409, 393 397, 393 377 C 393 28, 121 28, 96 391 Z" fill="currentColor"/>
            <circle cx="256" cy="252" r="28" fill="currentColor"/>
          </svg>
          Airplaten
        </div>
        <h1 class="admin-login-heading">Admin Sign In</h1>
        <p class="admin-login-sub">Enter your credentials to access the admin panel.</p>

        <form id="admin-login-form" novalidate>
          <div id="admin-login-error" class="admin-error" style="display:none; margin-bottom: var(--space-5);"></div>

          <div class="form-group" style="margin-bottom: var(--space-4);">
            <label class="form-label" for="admin-email">Email</label>
            <input
              id="admin-email"
              class="form-input"
              type="email"
              autocomplete="email"
              placeholder="you@example.com"
              required
            />
          </div>

          <div class="form-group" style="margin-bottom: var(--space-6);">
            <label class="form-label" for="admin-password">Password</label>
            <input
              id="admin-password"
              class="form-input"
              type="password"
              autocomplete="current-password"
              placeholder="••••••••"
              required
            />
          </div>

          <button type="submit" class="btn btn-primary" style="width:100%;" id="admin-login-btn">
            Sign In
          </button>
        </form>
      </div>
    </div>
  `

  const form = document.getElementById('admin-login-form')
  const errorEl = document.getElementById('admin-login-error')
  const btn = document.getElementById('admin-login-btn')

  form.addEventListener('submit', async (e) => {
    e.preventDefault()
    errorEl.style.display = 'none'

    const email = document.getElementById('admin-email').value.trim()
    const password = document.getElementById('admin-password').value

    if (!email || !password) {
      errorEl.textContent = 'Please enter your email and password.'
      errorEl.style.display = 'block'
      return
    }

    btn.disabled = true
    btn.textContent = 'Signing in…'

    try {
      await signIn(email, password)
      window.location.hash = '#/admin'
    } catch (err) {
      errorEl.textContent = err.message || 'Invalid email or password.'
      errorEl.style.display = 'block'
      btn.disabled = false
      btn.textContent = 'Sign In'
    }
  })
}
